<svg width="100%" height="100%" viewBox="0 0 50 50">
  <circle
    r="25"
    cx="25"
    cy="25"
    [ngStyle]="{ strokeDasharray: pieValue + ' ' + pieTotal }"
  />
</svg>
